<template>
  <div class="table-responsive">
    <table class="table dataTable text-nowrap m-0 p-0">
      <thead class="bg-white">
        <tr>
          <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
            Product Name
          </th>
          <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
            Product Code
          </th>
          <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
            Unit
          </th>
          <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
            Inventory Count
          </th>
          <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
            Total Quantity
          </th>
          <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
            Status
          </th>
          <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
            Actions
          </th>
        </tr>
      </thead>
      <tbody class="bg-white">
        <tr v-if="loading">
          <td colspan="12" class="text-center">
            <div
              class="text-center"
              style="padding-top: 100px; padding-bottom: 50px"
            >
              <span
                class="fa-solid fa-spinner fa-spin text-[#2463EB]"
                style="font-size: 8rem"
              ></span>
              <h3
                class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                style="padding-bottom: 100px"
              >
                Please wait while we load the list
              </h3>
            </div>
          </td>
        </tr>
        <tr
          v-for="l in Inventories"
          :key="l.id"
          :style="[l.quantity == 0 ? { color: 'red' } : { color: '#626262' }]"
          v-else
        >
          <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
            {{ l.productName }}
          </td>
          <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
            {{ l.productCode }}
          </td>
          <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
            {{ l.productUnit }}
          </td>
          <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
            {{ l.inventoryCount }}
          </td>
          <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
            {{ l.totalQuantity }}
          </td>
          <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
            <span
              :class="[
                'badge',
                l.quantity === 0 ? 'badge-danger' : 'badge-success',
              ]"
            >
              <span
                class="inline-block w-[10px] h-[10px] rounded-[1px]"
                :style="{
                  backgroundColor: l.quantity === 0 ? '#e42728' : '#16a249',
                }"
              ></span>
              <span class="text-[12px] font-normal leading-[16.94px]">
                {{ l.quantity === 0 ? "Inactive" : "Active" }}
              </span>
            </span>
          </td>
          <td>
            <button
              class="btn-no-border"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span
                class="text-[#98a2b3] dropdown text-2xl cursor-pointer relative outline-none active:outline-none shadow-none"
              >
                ...
              </span>
            </button>
            <ul
              class="dropdown-menu shadow-none"
              aria-labelledby="dropdownMenuButton"
            >
              <li
                class="text-[14px] font-normal leading-[14px] text-[#353535] cursor-pointer py-[10px] px-[16px] border-b"
                v-if="l.totalQuantity > 0"
                @click.prevent="viewProductInventoryList(l.productId)"
              >
                View
              </li>
              <li
                class="text-[14px] font-normal leading-[14px] cursor-pointer py-[10px] px-[16px]"
                @click.prevent="confirmDelete(l.id)"
                style="color: red"
              >
                Delete Product
              </li>
            </ul>
          </td>
        </tr>
        <tr v-if="!Inventories.length && !loading">
          <td colspan="12">
            <div class="text-center" style="padding-top: 50px">
              <span
                style="font-size: 4.615rem"
                class="mdi mdi-crosshairs-gps"
              ></span>
            </div>
            <h3 class="text-center" style="padding-bottom: 100px">
              You don't have any inventories.
            </h3>
          </td>
        </tr>
      </tbody>
    </table>

    <manageStockModal
      :closeModal="closeModal"
      v-if="isModalVisible"
      :ProductId="ProductId"
    />
  </div>
</template>

<script>
import manageStockModal from "./manageStockModal.vue";
export default {
  props: ["Inventories", "loading", "confirmDelete"],
  components: {
    manageStockModal,
  },
  data() {
    return {
      isModalVisible: false,
      ProductId: "",
    };
  },
  methods: {
    viewProductInventoryList(productId) {
      this.ProductId = productId;
      this.isModalVisible = true;
      document.body.style.overflow = "hidden";
    },
    closeModal() {
      this.isModalVisible = false;
      document.body.style.overflow = "auto";
    },
  },
};
</script>
